import React from "react";
import "./Meet_Doctor.css";
import Common_title from "../../common-components/common_title/Common_title";
import { Link } from "react-router-dom";

const Meet_Doctor = () => {
  return (
    <section className="meet_doctor_section">
      <div className="container">
        <div className="meet_doctor_title_holder">
          <Common_title text="⚓ MEET OUR DOCTOR" />
        </div>

        <div className="meet_doctor_content_holder">
          <div className="row">
            <div className="col-lg-3 col-md-12">
              <div className="doctor_image_holder">
                <img
                  src="/assets/images/about_us/doctor.jpeg"
                  alt="doctor-img"
                  className="doctor_img"
                />
              </div>
            </div>

            <div className="col-lg-9 col-md-12">
              <div className="doctor_text_holder">
                <h2 className="doctor_title">
                  Dr. (Mrs.) Pradnya Vinod Gawande
                </h2>
                <p className="doctor_subtitle">
                  DG Approved Medical Examiner | Consultant in Family &
                  Occupational Medicine
                </p>
                <div className="doctor_approval_holder">
                  <p className="approval_no">
                    DGS Approval No. : MAH/PN/16/2017
                  </p>
                </div>
                <p className="doctor_desc">
                  Dr. Pradnya Gawande has more than 11 years of experience in
                  marine medical examinations. Since 2014, she has successfully
                  conducted medicals for seafarers working with numerous
                  national and international shipping companies.
                </p>

                <h2 className="doctor_qualification">
                  Qualifications & Certification
                </h2>

                <ul>
                  <li>
                    Familiarization Course for Medical Examiner of Seafarers –
                    MASSA, Mumbai
                  </li>
                  <br />
                  <li>
                    Refresher Course for Medical Examiner of Seafarers – ASHA
                    Institute, Mumbai
                  </li>
                  <br />
                  <li>
                    Recognized by DG Shipping, MOP&W, Govt. of India, as per MS
                    Notice 2015
                  </li>
                </ul>

                <Link className="doctor_desc btn" target="_blank" to='https://www.google.com/search?sca_esv=9ede5de31d9ebd79&rlz=1C1OKWM_enIN952IN952&si=AMgyJEtREmoPL4P1I5IDCfuA8gybfVI2d5Uj7QMwYCZHKDZ-E09s4EhWLR8pmK2UVp5SctrOIQDtfXmiFBnSPEQrdNdtJ1Vbca__cm3s7DA4qCQhAhcPvpKo4w9n_3vsN-ung9xwL8ok&q=Shore+Clinic+Reviews&sa=X&ved=2ahUKEwjP4saNl9GRAxWw2DgGHRXeLFIQ0bkNegQIGxAD&biw=1745&bih=828&dpr=1.1'>For More Details...</Link>


              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Meet_Doctor;
